export default __webpack_public_path__ + "static/media/Grimherald Tunic.c0726375.jpg";